<app-system-message></app-system-message>
<!-- Container for the form with dynamic styling -->
<div [ngClass]="theme.getThemeClass()" class="container-fluid">
    <section [ngClass]="theme.getThemeClass()" class="card bg-light">
        <article class="card-body mx-auto article">
            <h4 class="card-title mt-0 text-center">{{ 'createLocation' | translate }}</h4>
            <form>
              <!-- Input field for address with Autocomplete -->
              <label class="label-spacer" for="distributor_name">{{ 'address' | translate }} <span class="requiredStar">*</span></label>
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"><i class="fas fa-search-location"></i></span>
                <input id="autocomplete" [(ngModel)]="this.entitiesLocationService.location_data.location" (keydown)="onInputAddressKeydown($event);"
                type="text" class="form-control" name="bin_location"
                placeholder="{{ 'clientcreateFormInputFindAddress' | translate }}"aria-label="Enter a place" aria-describedby="basic-addon1">
              </div>
              @if (!selectedOption) {
              <label class="label-spacer" for="distributor_name">{{ 'userType' | translate }} <span class="requiredStar">*</span></label>
             }
             @if (!selectedOption) {
             <div class="radioBtns">
              <label >
                <input type="radio" name="option" value="client" [(ngModel)]="selectedOption">
                {{'_client'|translate}}
               </label>
               <label>
                <input type="radio" name="option" value="distributor" [(ngModel)]="selectedOption">
                {{'_distributor'|translate}}
               </label>
                <label>
                  <input type="radio" name="option" value="operator" [(ngModel)]="selectedOption">
                  {{'chartLabelOperator'|translate}}
                </label>
             </div>
             }

              <!-- Client Input -->
              @if (selectedOption === 'client') {
              <div>
                @if (this.cognitoService.userType === 'muirwood') {
                <label class="label-spacer" for="distributor_name">{{ 'client' | translate }} <span class="requiredStar">*</span></label>
                }
              @if (this.cognitoService.userType === 'muirwood') {
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"><i class="fa-regular fa-address-card"></i></span>
                  <select
                    [(ngModel)]="selectedClient"
                    class="form-control ng-select"
                    name="client"
                    aria-label="Client Name"
                    aria-describedby="basic-addon1"
                    [ngClass]="{ 'has-value': selectedClient }"
                    (change)="selectedClientChange()"
                  >
                    <option value="">{{ 'client' | translate }}</option>
                    @for (client of clientOptions; track client.value) {
                      <option [value]="client.value">{{ client.label }}</option>
                    }
                  </select>
                  <span class="input-group-text" (click)="clearRadio()" style="cursor: pointer;"><i class="fa-solid fa-xmark"></i></span>
              </div>
              }
              </div>
              }
              <!-- Distributor Input -->
              @if (selectedOption === 'distributor') {
              <div>
                @if (this.cognitoService.userType === 'muirwood') {
                <label class="label-spacer" for="distributor_name">{{ '_distributor' | translate }} <span class="requiredStar">*</span></label>
                }
              @if (this.cognitoService.userType === 'muirwood') {
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-id-card"></i></span>
                <select
                  [(ngModel)]="selectedDistributor"
                  class="form-control ng-select"
                  name="client"
                  aria-label="Client Name"
                  aria-describedby="basic-addon1"
                  [ngClass]="{ 'has-value': selectedDistributor }"
                  (change)="selectedDistributorChange()"
                >
                  <option value="">{{ '_distributor' | translate }}</option>
                  @for (distributor of distributorOptions; track distributor.value) {
                    <option [value]="distributor.value">{{ distributor.label }}</option>
                  }
                </select>
                <span class="input-group-text" (click)="clearRadio()" style="cursor: pointer;"><i class="fa-solid fa-xmark"></i></span>
              </div>
              }
              </div>
              }

              <!-- Operator Input -->
              @if (selectedOption === 'operator') {
              <div>
                @if (this.cognitoService.userType === 'muirwood') {
                <label class="label-spacer" for="distributor_name">{{ 'chartLabelOperator' | translate }} <span class="requiredStar">*</span></label>
                }
              @if (this.cognitoService.userType === 'muirwood') {
              <div class="input-group mb-3">
                <span class="input-group-text" id="basic-addon1"><i class="fa-regular fa-id-card"></i></span>
                <select
                  [(ngModel)]="selectedOperator"
                  class="form-control ng-select"
                  name="client"
                  aria-label="Client Name"
                  aria-describedby="basic-addon1"
                  [ngClass]="{ 'has-value': selectedOperator }"
                  (change)="selectedOperatorChange()"
                >
                  <option value="">{{ 'chartLabelOperator' | translate }}</option>
                  @for (operator of operatorOptions; track operator.value) {
                    <option [value]="operator.value">{{ operator.label }}</option>
                  }
                </select>
                <span class="input-group-text" (click)="clearRadio()" style="cursor: pointer;"><i class="fa-solid fa-xmark"></i></span>
              </div>
              }
              </div>
              }

              <!-- Submit button -->
              <nav class="form-group buttonDiv">
                  <button (click)="returnToEntities()" [ngClass]="theme.getThemeClass()" type="button" class="btn btn-block btnCancel">{{ 'clientcreateFormBtnCancel' | translate }}</button>
                  <button [disabled]="this.systemMessageService.buttonBlocked" [ngClass]="theme.getThemeClass()" (click)="onSubmit(); disableButton()" type="button" class="btn btn-block btnCreate">{{ 'clientcreateFormBtnCreateClient' | translate }}</button>
              </nav>
            </form>
        </article>
    </section>
</div>
